import {memo,Fragment, useState, useEffect} from 'react'
import {jwtDecode} from 'jwt-decode'
//React-bootstrap
import { Navbar,Dropdown, Container} from 'react-bootstrap'

// Container,Dropdown,Button,Card
// import Card from '../../../Card'
import { Link, useNavigate } from 'react-router-dom'
import CustomToggle from '../../../dropdowns'

//img 
import skyraan from '../../../../assets/images/skyraan.png'
// logo
import Logo from '../../components/logo'

const HeaderStyle1 = memo(({}) => {
    // const[show, setShow] = useState(true)
    const  navigate = useNavigate();

    const [user, setUser] = useState(null);

    useEffect(()=>{
        const token = localStorage.getItem('token');
        if(token){
            const decodeUser = jwtDecode(token);
            setUser(decodeUser)
        }
    },[])

    const handleLogout = () =>{
        localStorage.removeItem('token');
        navigate('/frontend/iconfinder/login')
    }
   
    return (
        
        <Fragment>   
            <Navbar expand="xl" className="nav  iq-navbar">
                <Container fluid className="navbar-inner">                       
                        
                        <Navbar.Collapse  className="col-md-2" id="navbarSupportedContent">
                            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

                                
                                
                                <Dropdown as='li' className="nav-item">
                                    <Dropdown.Toggle as={CustomToggle} variant=" nav-link py-0 d-flex align-items-center" href="#" id="navbarDropdown">
                                    <img src={skyraan} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    
                                        <div className="caption ms-3 ">
                                            <h6 className="mb-0 caption-title">{user?.name || 'User' }</h6>
                                            <p className="mb-0 caption-sub-title">{user?.role || 'Role'}</p>
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul" className="dropdown-menu-end">
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                      
                            </ul>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
        </Fragment>
    )
})

export default HeaderStyle1;
